module.exports = __webpack_public_path__ + "img/icon-books.790699c1.svg";